import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared";
import { getFamilyDonations } from "../../service/DonationApi";
import { useParams, useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";
import '../../pages/general/General.css';

const DonationView = () => {
  useCheckAccess('DonationRW,EventsRW');
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const guestId = queryParams.get("guestId");

  useEffect(() => {
    const fetchFamilyDonations = async () => {
      setLoading(true);
      try {
        const response = await getFamilyDonations({
          familyId: id === 'guest' ? '' : id,
          guestId: guestId || '',
        });
        setDonations(response || []);
      } catch (error) {
        console.error('Error fetching donations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyDonations();
  }, [id, guestId]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <div>
      <Navbar />
      <Helmet>
        <title>View Family Donations</title>
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className='general_body'>
            <Breadcrumbs /><br />
            <h2>நன்கொடை விவரங்கள்</h2>
            <br />

            {donations.length === 0 ? (
              <p>நன்கொடைகள் எதுவும் கிடைக்கவில்லை..</p>
            ) : (
              <div className="table-container">
                <table className="table" aria-label="Recent Families">
                  <thead>
                    <tr>
                      <th>நன்கொடை விவரங்கள்</th>
                      <th>நிலை</th>
                    </tr>
                  </thead>
                  <tbody>
                    {donations.map((donation, index) => (
                      <tr key={index}>
                        <td>
                          {donation.category} - {donation.subcategory}
                        </td>
                        <td>
                          <>
                            {donation.familyMemberFirstName ? `${donation.familyMemberFirstName} ` : ''}{donation.transactionDate ? new Date(donation.transactionDate._seconds * 1000).toLocaleDateString() : ''}{' அன்று ₹' + donation.amount + ' செலுத்தினார் '}
                          </>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            )}

            <br />
            <button type="button" onClick={() => navigate(`/donation/create`)}>➕ புதிய நன்கொடையைச் சேர்க்கவும்</button>
            <button type="button" onClick={() => navigate(`/donation`)}>🏠 நன்கொடை நிர்வாகம்</button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DonationView;
